import React, { useState } from "react";
import Modal from "../base/Modal";
import { fieldsToSchema } from "../NewWorkflow/utils/schemaUtils";

const ConditionalNodeModal = ({ mode, nodeData, onSave, onDelete, onClose, viewOnly }) => {
  const [condition, setCondition] = useState(nodeData?.data?.condition || "");

  const handleSave = () => {
    const outputFields = [{
      id: 'condition',
      fieldName: 'condition',
      dataType: 'Boolean',
      children: [],
    },
    {
      id: 'reasoning',
      fieldName: 'reasoning',
      dataType: 'String',
      children: [],
    },];
    const schema = fieldsToSchema(outputFields);

    const updatedNode = {
      ...nodeData,
      data: { condition, jsonOutput: true, jsonOutputSchema: schema },
    };
    onSave(updatedNode);
  };

  return (
    <Modal
      title={viewOnly ? "Conditional Node" : mode === "add" ? "Add Conditional Node" : "Edit Conditional Node"}
      isOpen={true}
      onClose={onClose}
    >
      <div className="p-6 rounded shadow-lg overflow-auto">
        <textarea
          className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 text-zinc-100 rounded-md
          placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#5652CF] focus:border-transparent
          transition duration-200 resize-none"
          value={condition}
          disabled={viewOnly}
          rows={4}
          placeholder="e.g. Mail is related to UI Issue"
          onChange={(e) => setCondition(e.target.value)}
        />
        {!viewOnly && (<div className="flex justify-end gap-3 mt-2">
          {mode === "edit" && (
            <button
              className="px-4 py-2 text-zinc-300 bg-zinc-800 hover:bg-zinc-700 
                border border-zinc-700 rounded-md transition duration-200
                focus:outline-none focus:ring-2 focus:ring-zinc-500"
              onClick={() => onDelete(nodeData.id)}
            >
              Delete Node
            </button>
          )}
          <button
            // className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
            className="px-4 py-2 text-zinc-300 bg-zinc-800 hover:bg-zinc-700 
              border border-zinc-700 rounded-md transition duration-200
              focus:outline-none focus:ring-2 focus:ring-zinc-500"
            onClick={handleSave}
          >
            {mode === "add" ? "Add Node" : "Save Changes"}
          </button>
        </div>)}

      </div>
    </Modal>
  );
};

export default ConditionalNodeModal;
